module.exports = __webpack_public_path__ + "static/media/homem_r2_c1.0898da54.jpg";